import { render } from "./PriceLabel.vue?vue&type=template&id=fac1be66"
import script from "./PriceLabel.vue?vue&type=script&lang=js"
export * from "./PriceLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__